import React, { useReducer } from 'react';
import { StyleSettingsCarouselUploaderActionTypes } from './styleSettingsCarouselUploaderActions';
import {
	StyleSettingsCarouselUploaderContext,
	styleSettingsCarouselUploaderInitialState,
	TTypeOfErrorModalWindow,
	TTypeOfModalWindow,
} from './styleSettingsCarouselUploaderContext';
import { styleSettingsCarouselUploaderReducer } from './styleSettingsCarouselUploaderReducer';
import { postMediaFileForStyleSettings } from 'backend/additionalInformation';

const StyleSettingsCarouselUploaderState: React.FC = ({ children }) => {
	const [state, dispatch] = useReducer(
		styleSettingsCarouselUploaderReducer,
		styleSettingsCarouselUploaderInitialState,
	);

	const setCropperSrc = (value: string | null) => {
		dispatch({
			type: StyleSettingsCarouselUploaderActionTypes.SET_CROPPER_SRC,
			payload: {
				src: value,
			},
		});
	};

	const changeTypeOfModalWindow = (value: TTypeOfModalWindow) => {
		dispatch({
			type: StyleSettingsCarouselUploaderActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW,
			payload: {
				typeOfModalWindow: value,
			},
		});
	};

	const changeTypeOfErrorModalWindow = (value: TTypeOfErrorModalWindow) => {
		dispatch({
			type: StyleSettingsCarouselUploaderActionTypes.CHANGE_TYPE_OF_ERROR_MODAL_WINDOW,
			payload: {
				typeOfErrorModalWindow: value,
			},
		});
	};

	// TODO think about it later.
	const uploadImage = async (image: Blob) => {
		const formData = new FormData();
		const createImageName = () => {
			const indexOfBlobTypeSeparator = image.type.indexOf('/');
			const fileExtension = image.type.slice(indexOfBlobTypeSeparator + 1);
			return `image.${fileExtension}`;
		};
		formData.append('file', image, createImageName());
		try {
			const response = await postMediaFileForStyleSettings(formData);
			return response.data.fileId;
		} catch (err) {
			// changeTypeOfErrorModalWindow('fileUploadError');
			return undefined;
		} finally {
			// hideGroupLoader();
		}
	};
	// TODO think about it later.

	return (
		<StyleSettingsCarouselUploaderContext.Provider
			value={{
				setCropperSrc,
				changeTypeOfModalWindow,
				changeTypeOfErrorModalWindow,
				uploadImage,
				cropperSrc: state.cropperSrc,
				typeOfModalWindow: state.typeOfModalWindow,
				typeOfErrorModalWindow: state.typeOfErrorModalWindow,
			}}>
			{children}
		</StyleSettingsCarouselUploaderContext.Provider>
	);
};

export default StyleSettingsCarouselUploaderState;
